<div *ngIf="mediaEmbed == null || mediaEmbed == ''; else EmbedMediaCode" class="embedImage">
  <ng-container *ngIf="mediaName == '' || isDownloadFile; else mediaPlayer">
    <ng-container *ngIf="
        (mediaName == '' && !isOfflineSurvey) ||
        (isDownloadFile && mediaName == '' && !isOfflineSurvey) ||
        (isDownloadFile && mediaName != '')
      ">
      <ng-container *ngIf="isPlayedFile(mediaUrl); else nonPlayedEmbed">
        <ng-container *ngIf="isAudioFile(mediaUrl); else movFilePlayer">
          <app-audio-player [path]="this.mediaUrl + this.mediaName"
                            [isAnsMedia]="isAnswerMedia()"></app-audio-player>
        </ng-container>

        <ng-template #movFilePlayer>
          <video width="100%"
                 [src]="this.mediaUrl + this.mediaName"
                 controls
                 disablepictureinpicture
                 (webkitfullscreenchange)="onFullScreen()"
                 controlslist="nodownload">
            Your browser does not support video element.
          </video>
        </ng-template>
      </ng-container>

      <ng-template #nonPlayedEmbed>
        <a target="_blank" href="{{ mediaUrl + mediaName }}">
          <ng-container *ngIf="mediaName == ''; else downloadFile">
            <img border="0" src="{{ path }}/images/icons/embed_video.svg" alt="{{ MediaAlt }}" />
          </ng-container>
          <ng-template #downloadFile>
            <ng-container *ngIf="isVideoFile; else audioFile">
              <img border="0"
                   src="{{ path }}/images/icons/video-thumbnail.svg"
                   alt="{{ MediaAlt }}" />
            </ng-container>
            <ng-template #audioFile>
              <img border="0"
                   src="{{ path }}/images/icons/audio-thumbnail.svg"
                   alt="{{ MediaAlt }}" />
            </ng-template>
          </ng-template>
        </a>
      </ng-template>
    </ng-container>
  </ng-container>

  <ng-template #mediaPlayer>
    <ng-container *ngIf="isVideoFile; else audioFile">
      <video width="100%"
             id="{{ idKey }}_video"
             [src]="this.mediaUrl + this.mediaName"
             controls
             disablepictureinpicture
             (webkitfullscreenchange)="onFullScreen()"
             controlslist="nodownload">
        Your browser does not support video element.
      </video>
    </ng-container>
    <ng-template #audioFile>
      <app-audio-player [path]="this.mediaUrl + this.mediaName"
                        [isAnsMedia]="isAnswerMedia()"></app-audio-player>
    </ng-template>

    <div *ngIf="isPlayMedia">
      <app-media-player [path]="this.mediaUrl + this.mediaName"
                        [isVideoFile]="isVideoFile"
                        (playMedia)="playMedia($event)"></app-media-player>
    </div>
  </ng-template>
</div>
<ng-template #EmbedMediaCode>
  <div
    id="{{ idKey }}_embed"
    #embedContainer
    *ngIf="!isOfflineSurvey"
    [innerHTML]="mediaEmbed | headerFooterHtml"
  ></div>
</ng-template>
